import styled from 'styled-components';
import { bootstrapMax } from '../../../utils/devices';

export const Container = styled.div`
  @media ${bootstrapMax.sm} {
    padding: 0 15px;
  }
`;
